<script lang="ts">
  import { dndzone } from "svelte-dnd-action";
  import Annotation from "../atoms/Annotation.svelte";
  import ListItem from "../atoms/ListItem.svelte";
  import { flip } from "svelte/animate";

  export let models = [];
  export let flipDurationMs = 300;
  export let handleDndConsider;
  export let handleDndFinalize;
  export let handleModel;
  export let selected;
</script>

<div class="order mt-6">
  <Annotation>ドラッグ＆ドロップで並び順を変更</Annotation>

  <ul
    class="mt-2 cursor-pointer"
    use:dndzone={{ items: models, flipDurationMs }}
    on:consider={handleDndConsider}
    on:finalize={handleDndFinalize}
  >
    {#each models as m (m.id)}
      <div animate:flip={{ duration: flipDurationMs }}>
        <ListItem {handleModel} model={m} {selected} />
      </div>
    {/each}
  </ul>
</div>

<style lang="postcss">
  .order {
    min-width: 250px;
  }
</style>
